import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { oeeReports } from 'eflex/constants/bi-report-options';
import QueryParams from 'eflex/constants/bi-query-params';
import moment from 'moment-timezone';

export default class BiOeeFaultsController extends Controller {
  // jscpd:ignore-start
  @tracked drawerCollapsed = false;
  @tracked userIds = [];
  @tracked stationIds = [];
  @tracked shiftNames = [];
  @tracked beginDate = moment().startOf('day').toISOString();
  @tracked endDate = moment().endOf('day').toISOString();
  @tracked states = [];
  @tracked refresher = false;
  queryParams = Object.keys(QueryParams);
  selectedReport = oeeReports.faultCodeSummary;

  get reportOptions() {
    return Object.values(oeeReports);
  }

  @action
  onSearch(params) {
    this.resetCriteria();
    Object.assign(this, params);
  }

  @action
  resetCriteria() {
    Object.assign(this, {
      userIds: [],
      stationIds: [],
      shiftNames: [],
      beginDate: null,
      endDate: null,
      states: [],
    });
  }

  @action
  refresh() {
    this.refresher = true;
  }
  // jscpd:ignore-end
}
